import React from 'react'
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import InputDisplay from "./InputDisplay";

const styles = theme => ({
  container: {
    paddingBottom: 15
  },
  stepTitle: {
    marginBottom: 10
  },
  inputArea: {
    marginBottom: 20,
    width: "100%"
  },
});

const StationDetails = ({classes, stationPump}) => {
  return (
    <div className={classes.container}>
      <Typography variant="title" component="h3" className={classes.stepTitle}>Aseman tiedot</Typography>
      <InputDisplay idName="stationName" labelText="Nimi" value={stationPump.name} isDisabled={true}/>
      <InputDisplay idName="meterNum" labelText="Mittari" value={stationPump.pumpNumber} isDisabled={true}/>
    </div>
  )
}

export default withStyles(styles)(StationDetails);



// WEBPACK FOOTER //
// ./src/components/Steps/StationDetails.js